// extracted by mini-css-extract-plugin
export var scroll = "style-module--scroll--44788";
export var text = "style-module--text--616cb";